import { render, staticRenderFns } from "./InventoryReportDetailed.vue?vue&type=template&id=327f4bb5&scoped=true&"
import script from "./InventoryReportDetailed.vue?vue&type=script&lang=js&"
export * from "./InventoryReportDetailed.vue?vue&type=script&lang=js&"
import style0 from "./InventoryReportDetailed.vue?vue&type=style&index=0&id=327f4bb5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327f4bb5",
  null
  
)

export default component.exports